import React from "react";
import { Link, useLocation } from "react-router-dom";

const LandingHero = ({ badge, title, highlight, subtitle, ctaText, bgClass, highlightClass }) => {
    const location = useLocation();
    const loginUrl = `/login?redirect=${encodeURIComponent(location.pathname)}`;

    return (
        <section className={`py-32 text-center ${bgClass || "bg-gradient-to-br from-blue-50 to-blue-100"}`}>
            <div className="max-w-5xl mx-auto px-6">
                {badge && (
                    <span className="inline-block bg-brand-blue text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-5">
                        {badge}
                    </span>
                )}
                <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight mb-5">
                    {title}
                    {highlight && (
                        <><br /><span className={highlightClass || "text-brand-blue"}>{highlight}</span></>
                    )}
                </h1>
                <p className="text-lg text-gray-500 max-w-2xl mx-auto mb-8">{subtitle}</p>
                <Link
                    to={loginUrl}
                    className="inline-block bg-brand-blue text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-800 transition-all hover:-translate-y-0.5 hover:shadow-lg"
                >
                    {ctaText}
                </Link>
            </div>
        </section>
    );
};

export default LandingHero;
